import React, { useState } from "react";
import {
  Container,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Alert,
  Row,
  Col,
  FormFeedback,
  Progress,
} from "reactstrap";
import { axiosApi } from "../../redux/actions/index";
import { API_URL } from "../../redux/actions/types";

function getPasswordStrength(password) {
  let score = 0;
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;
  return score;
}

function getStrengthColor(score) {
  if (score <= 1) return "danger";
  if (score <= 2) return "warning";
  if (score <= 3) return "info";
  return "success";
}

function getStrengthLabel(score) {
  if (score <= 1) return "Muy débil";
  if (score <= 2) return "Débil";
  if (score <= 3) return "Moderada";
  if (score <= 4) return "Fuerte";
  return "Muy fuerte";
}

function validatePassword(password) {
  const errors = [];
  if (password.length < 8) errors.push("Mínimo 8 caracteres");
  if (!/[A-Z]/.test(password)) errors.push("Al menos una mayúscula");
  if (!/[0-9]/.test(password)) errors.push("Al menos un número");
  return errors;
}

function ChangePassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, color: "", message: "" });

  const passwordErrors = newPassword ? validatePassword(newPassword) : [];
  const passwordStrength = getPasswordStrength(newPassword);
  const passwordsMatch = newPassword === confirmPassword;
  const isFormValid =
    oldPassword &&
    newPassword &&
    confirmPassword &&
    passwordErrors.length === 0 &&
    passwordsMatch;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) return;

    setLoading(true);
    try {
      const response = await axiosApi.put(`${API_URL}/api/auth/password`, {
        oldPassword,
        password: newPassword,
      });
      setAlert({
        show: true,
        color: "success",
        message: response.data.message || "Contraseña actualizada correctamente",
      });
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      const message =
        err.response?.data?.message || "Error al cambiar la contraseña";
      setAlert({ show: true, color: "danger", message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="container-border p-3 mt-3">
      <h4 className="mb-4">Cambiar Contraseña</h4>
      {alert.show && (
        <Alert
          color={alert.color}
          toggle={() => setAlert({ ...alert, show: false })}
        >
          {alert.message}
        </Alert>
      )}
      <Row>
        <Col sm="12" lg="6">
          <Form onSubmit={onSubmit}>
            <FormGroup>
              <Label>Contraseña actual</Label>
              <Input
                type="password"
                placeholder="· · · · · ·"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                disabled={loading}
              />
            </FormGroup>
            <FormGroup>
              <Label>Nueva contraseña</Label>
              <Input
                type="password"
                placeholder="· · · · · ·"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                disabled={loading}
                invalid={newPassword.length > 0 && passwordErrors.length > 0}
                valid={newPassword.length > 0 && passwordErrors.length === 0}
              />
              {newPassword.length > 0 && passwordErrors.length > 0 && (
                <FormFeedback>{passwordErrors.join(", ")}</FormFeedback>
              )}
              {newPassword.length > 0 && (
                <div className="mt-2">
                  <small className="text-muted">
                    Fortaleza: {getStrengthLabel(passwordStrength)}
                  </small>
                  <Progress
                    value={(passwordStrength / 5) * 100}
                    color={getStrengthColor(passwordStrength)}
                    className="mt-1"
                    style={{ height: "6px" }}
                  />
                </div>
              )}
            </FormGroup>
            <FormGroup>
              <Label>Confirmar nueva contraseña</Label>
              <Input
                type="password"
                placeholder="· · · · · ·"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                disabled={loading}
                invalid={confirmPassword.length > 0 && !passwordsMatch}
                valid={confirmPassword.length > 0 && passwordsMatch}
              />
              {confirmPassword.length > 0 && !passwordsMatch && (
                <FormFeedback>Las contraseñas no coinciden</FormFeedback>
              )}
            </FormGroup>
            <Button color="success" disabled={loading || !isFormValid}>
              {loading ? "Guardando..." : "Cambiar Contraseña"}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default ChangePassword;
